import {mergeCurrentFormValues} from './agentFormValues';
import {resetAgentEventState} from './resetAgentEventState';
import {
    isIntentSwitch,
    isNewEventRequest,
    rememberProposalContext,
    rememberUiActionContext,
    switchSessionFlow,
} from './agentSessionMemory';
import type {AgentResponse} from '../../../redux/aiAgent/aiAgent.type';

/** What the turn just proposed or opened becomes the context the next turn is read against. */
export function rememberTurnContext(payload: AgentResponse): void {
    const {uiAction, pendingProposal} = payload;
    if(isNewEventRequest(uiAction.payload) || pendingProposal?.newEvent) {
        resetAgentEventState();
    }
    // Before the turn is remembered, so what it opens is locked onto instead of the flow the
    // producer just left.
    if(isIntentSwitch(uiAction.payload) || isIntentSwitch(pendingProposal)) {
        switchSessionFlow();
    }
    if(pendingProposal) {
        rememberProposalContext(pendingProposal);
        mergeCurrentFormValues(pendingProposal.fields);
        return;
    }
    rememberUiActionContext(uiAction);
    mergeCurrentFormValues(uiAction.payload?.fields);
}
